import { FileExcelOutlined, SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Dropdown, Input, Menu, message, Popconfirm, Row, Space, Table, Tooltip} from 'antd';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { font } from '../../Common/font';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as PlanPrintIcon } from '../../Images/SimplePrintIcon.svg';
import { ReactComponent as PrintIcon } from '../../Images/PrintIcon.svg';
import { ReactComponent as ViewIcon } from '../../Images/ViewIcon.svg';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import {
  createPriority,
  deleteWorkOrder,
  fetchOpenWorkOrderStatistics,
  fetchWorkOrderById,
  fetchWorkOrderListByfilter,
  fetchWorkOrderReport,
} from '../../slices/work-order';
import { createActivityLog } from '../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchDieProfileByOpenWorkOrder,
  resetDieProfileOpenWorkOrderData,
} from '../../slices/die-profile';
import {
  fetchActiveCustomer,
  resetCurrentCustomerPage,
  resetCustomerList,
} from '../../slices/customer';
import moment from 'moment';
import { Option } from 'antd/es/mentions';
import logo from '../../Images/alux-logo.png';
import eventBus from '../../utils/eventBus';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

// dummy comment
function WorkOrderFilterList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState(
    localStorage.getItem('WorkOrderList_filter') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('WorkOrderList_filter') || '',
  );
  const [isLoading, setIsLoading] = useState(false);
  const [pagesize] = useState(10000);
  const [customerId, setCustomerId] = useState(null);
  const [profileId, setProfileId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedDieId, setSelectedDieId] = useState(null);
  const [selectedDieName, setSelectedDieName] = useState('');
  const [activeFilter, setActiveFilter] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);

  const { data = [], openWorkOrderStatisticsData, totalRecord } = useSelector(state => state.workOrder);
  const { user: currentUser } = useSelector(state => state.auth);
  const ipAddress = useSelector(state => state.ip.ipAddress);
  const { data: settingData } = useSelector(state => state.setting);
  const [orderData, setOrderData] = useState([]);
  const [summaryData, setSummaryData] = useState();
  const [resultCount, setResultCount] = useState(0);
  const [total_summary, setTotalSummary] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expandedRowData, setExpandedRowData] = useState({});
  const [expandedPriorityRowKeys, setExpandedPriorityRowKeys] = useState([]);
  const {
    list: customerList,
    loading: customerLoading,
    currentPage: customerCurrentPageFromStore,
    hasMore: customerHasMoreFromStore,
  } = useSelector(state => state.customer);

  const {
    openWorkOrderData: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const companyLogo = settingData?.company_settings?.company_logo || logo;

  const debouncedFetchDieProfile = useRef(
    debounce(searchTerm => {
      dispatch(resetDieProfileOpenWorkOrderData());
      dispatch(resetCustomerList());
      dispatch(
        fetchDieProfileByOpenWorkOrder({ page: 1, pagesize: 100, search: searchTerm }),
      );
    }, 300),
  ).current;

  const fetchOpenWorkOrderStatisticsData = useCallback(async () => {
    try {
      await dispatch(fetchOpenWorkOrderStatistics());
    } catch (error) {
      message.error('Failed to fetch work orders.');
    } finally {
    }
  },
    [dispatch]
  );

  useEffect(() => {
    dispatch(fetchAndSetIpAddress());
    dispatch(resetCustomerList());
    dispatch(fetchActiveCustomer({ page: 1, pagesize: 50000 }));
    dispatch(fetchDieProfileByOpenWorkOrder({ page: 1, pagesize: 50000 }));
    
  }, [dispatch]);

  useEffect(() => {
    fetchOpenWorkOrderStatisticsData();
  }, [ fetchOpenWorkOrderStatisticsData]);

  const fetchWorkOrders = useCallback(
    async ({ page, pagesize, search, orderBy }) => {
      try {
        setIsLoading(true);
        await dispatch(
          fetchWorkOrderListByfilter({
            page,
            pagesize,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
            //...(customerId && { customer_id: customerId }),
            //...(profileId && { profile_id: profileId }),
          }),
        ).unwrap();
      } catch (error) {
        message.error('Failed to fetch work orders.');
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch],
  );

  const fetchWorkOrderData = useCallback(() => {
    setLoading(true);

    const params = {
      page,
      pagesize,
      ...(search && { search }),
    };

    if (activeFilter === 'customer' && selectedCustomerId) {
      params.customer_id = selectedCustomerId;
    } else if (activeFilter === 'die' && selectedDieId) {
      params.die_id = selectedDieId;
    } else {
      setLoading(false);
      return;
    }
    dispatch(fetchWorkOrderReport(params))
      .then(response => {
        const mergedData = () => {
          const grouped = {};
          response?.payload?.data.forEach(item => {
            const key = `${item.workorder_no}-${item.po_no}`;
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(item);
          });
          const result = [];
          Object.values(grouped).forEach(group => {
            group.forEach((row, index) => {
              result.push({
                ...row,
                customer_rowSpan: index === 0 ? group.length : 0,
                workorder_rowSpan: index === 0 ? group.length : 0,
                po_rowSpan: index === 0 ? group.length : 0,
                totalKg_rowSpan: index === 0 ? group.length : 0,
              });
            });
          });
          return result;
        };

        let finalResult = mergedData();
        setOrderData(finalResult);

        // Calculate summary
        const summary = {
          order_pcs: 0,
          order_kgs: 0,
          packed_pcs: 0,
          packed_kgs: 0,
          warehouse_pcs: 0,
          warehouse_kgs: 0,
          dispatched_pcs: 0,
          dispatched_kgs: 0,
          pending_pcs: 0,
          pending_kgs: 0,
        };
        finalResult.forEach(row => {
          summary.order_pcs += Number(row.order_pcs) || 0;
          summary.order_kgs += Number(row.order_kgs) || 0;
          summary.packed_pcs += Number(row.packed_pcs) || 0;
          summary.packed_kgs += Number(row.packed_kgs) || 0;
          summary.warehouse_pcs += Number(row.warehouse_pcs) || 0;
          summary.warehouse_kgs += Number(row.warehouse_kgs) || 0;
          summary.dispatched_pcs += Number(row.dispatched_pcs) || 0;
          summary.dispatched_kgs += Number(row.dispatched_kgs) || 0;
          summary.pending_pcs += Number(row.pending_pcs) || 0;
          summary.pending_kgs += Number(row.pending_kgs) || 0;
        });
        setTotalSummary(summary);
      })
      .catch(error => {
        console.error('Error fetching work order report:', error);
        setOrderData([]);
        message.error('Failed to fetch work order report');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, activeFilter, page, pagesize, search, selectedCustomerId, selectedDieId]);

  useEffect(() => {
    fetchWorkOrders({ page, pagesize, search, orderBy });
  }, [fetchWorkOrders, page, pagesize, orderBy, search]);

   useEffect(() => {
    const handleReload = () => {
      fetchWorkOrders({ page, pagesize, ...(search && { search })});
      fetchOpenWorkOrderStatisticsData();
    };

    eventBus.on("financialYear:refresh", handleReload);

    return () => {
      eventBus.off("financialYear:refresh", handleReload);
    };
  }, [fetchWorkOrders, fetchOpenWorkOrderStatisticsData, page, pagesize, search]);

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('WorkOrderList_filter', value);
    setPage(1);
    if (activeFilter === 'customer' && selectedCustomerId) {
      fetchWorkOrderDataWithSearch(value);
    } else if (activeFilter === 'die' && selectedDieId) {
      fetchWorkOrderDataWithSearch(value);
    } else {
      fetchWorkOrders({
        page: 1,
        pagesize,
        search: value,
        orderBy,
        customerId,
        profileId,
      });
    }
  };

  const fetchWorkOrderDataWithSearch = (searchValue = '') => {
    setLoading(true);

    const params = {
      page: 1,
      pagesize,
      ...(searchValue && { search: searchValue }),
    };

    if (activeFilter === 'customer' && selectedCustomerId) {
      params.customer_id = selectedCustomerId;
    } else if (activeFilter === 'die' && selectedDieId) {
      params.die_id = selectedDieId;
    }

    dispatch(fetchWorkOrderReport(params))
      .then(response => {
        const mergedData = () => {
          const grouped = {};
          response?.payload?.data.forEach(item => {
            const key = `${item.workorder_no}-${item.po_no}`;
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(item);
          });
          const result = [];
          Object.values(grouped).forEach(group => {
            group.forEach((row, index) => {
              result.push({
                ...row,
                customer_rowSpan: index === 0 ? group.length : 0,
                workorder_rowSpan: index === 0 ? group.length : 0,
                po_rowSpan: index === 0 ? group.length : 0,
                totalKg_rowSpan: index === 0 ? group.length : 0,
              });
            });
          });
          return result;
        };

        const finalResult = mergedData();
        setOrderData(finalResult);

        setSummaryData(response?.payload?.total_summary);
        setResultCount(finalResult.length);

        const summary = {
          order_pcs: 0,
          order_kgs: 0,
          packed_pcs: 0,
          packed_kgs: 0,
          warehouse_pcs: 0,
          warehouse_kgs: 0,
          dispatched_pcs: 0,
          dispatched_kgs: 0,
          pending_pcs: 0,
          pending_kgs: 0,
        };
        finalResult.forEach(row => {
          summary.order_pcs += Number(row.order_pcs) || 0;
          summary.order_kgs += Number(row.order_kgs) || 0;
          summary.packed_pcs += Number(row.packed_pcs) || 0;
          summary.packed_kgs += Number(row.packed_kgs) || 0;
          summary.warehouse_pcs += Number(row.warehouse_pcs) || 0;
          summary.warehouse_kgs += Number(row.warehouse_kgs) || 0;
          summary.dispatched_pcs += Number(row.dispatched_pcs) || 0;
          summary.dispatched_kgs += Number(row.dispatched_kgs) || 0;
          summary.pending_pcs += Number(row.pending_pcs) || 0;
          summary.pending_kgs += Number(row.pending_kgs) || 0;
        });
        setTotalSummary(summary);
      })
      .catch(error => {
        console.error('Error fetching work order report:', error);
        setOrderData([]);
        setTotalSummary(null);
        message.error('Failed to fetch work order report');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePrint = async () => {
    try {
      setLoading(true);
      const params = {
        page: 1,
        pagesize: 10000,
      };

      if (activeFilter === 'customer' && selectedCustomerId) {
        params.customer_id = selectedCustomerId;
      } else if (activeFilter === 'die' && selectedDieId) {
        params.die_id = selectedDieId;
      } else {
        return;
      }

      const response = await dispatch(fetchWorkOrderReport(params));
      const allData = response?.payload?.data || [];

      if (activeFilter === 'die') {
        setSelectedDieName(allData[0]?.section);
      }

      const totals = {
        order_pcs: 0,
        order_kgs: 0,
        packed_pcs: 0,
        packed_kgs: 0,
        warehouse_pcs: 0,
        warehouse_kgs: 0,
        dispatched_pcs: 0,
        dispatched_kgs: 0,
        pending_pcs: 0,
        pending_kgs: 0,
      };

      allData.forEach(row => {
        totals.order_pcs += Number(row.order_pcs) || 0;
        totals.order_kgs += Number(row.order_kgs) || 0;
        totals.packed_pcs += Number(row.packed_pcs) || 0;
        totals.packed_kgs += Number(row.packed_kgs) || 0;
        totals.warehouse_pcs += Number(row.warehouse_pcs) || 0;
        totals.warehouse_kgs += Number(row.warehouse_kgs) || 0;
        totals.dispatched_pcs += Number(row.dispatched_pcs) || 0;
        totals.dispatched_kgs += Number(row.dispatched_kgs) || 0;
        totals.pending_pcs += Number(row.pending_pcs) || 0;
        totals.pending_kgs += Number(row.pending_kgs) || 0;
      });

      const printWindow = window.open('', '_blank');
      const titleText =
        activeFilter === 'customer'
          ? allData[0]?.customer_name
          : activeFilter === 'die'
            ? `Profile ${allData[0]?.section}`
            : '';
      printWindow.document.write(`
        <html>
          <head>
            <title>Work Order Report</title>
            <style>
              @media print {
                body {
                  font-family: Arial, sans-serif;
                  margin: 2mm;
                  padding: 0;
                  font-size: 9px;
                }
                .print-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 10px;
                   font-size: 10px !important;
                }
                .print-table th, .print-table td {
                  border: 1px solid #ddd;
                  padding: 4px;
                  text-align: left;
                }
                .print-table th {
                  background-color: #f0f0f0;
                  font-weight: bold;
                }
                .print-table tr:nth-child(even) {
                  background-color: #f9f9f9;
                }
                .total-row {
                  font-weight: bold;
                  background-color: #e6e6e6 !important;
                  page-break-before: avoid;
                  page-break-after: always;
                }
                .table-container {
                  max-height: none !important;
                  overflow: visible !important;
                }
                img {
                  max-width: 60px;
                  max-height: 60px;
                  object-fit: contain;
                }
                .title {
                  text-align: center;
                  font-size: 14px;
                  margin-bottom: 10px;
                }
                @page {
                  size: landscape;
                  margin: 2mm;
                }
                .no-print { display: none; }
                tfoot { 
                  display: table-row-group; 
                }
              }
            </style>
          </head>
          <body>
            <div class="title"><h1>${titleText}</h1></div>
            <div class="table-container">
              <table class="print-table">
                ${generateTableHeader()}
                ${generateTableBody(allData)}
                ${generateTotalRow(totals)}
              </table>
            </div>
            <script>
              window.onload = function() {
                setTimeout(function() {
                  window.print();
                  window.close();
                }, 200);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } catch (error) {
      console.error('Error during printing:', error);
      message.error('Failed to print report');
    } finally {
      setLoading(false);
    }
  };

  const generateTableHeader = () => {
    const headers = [
      { title: 'Sr.No.', rowspan: 2 },
      ...(activeFilter === 'die' ? [{ title: 'Customer Name', rowspan: 2 }] : []),
      { title: 'Order No / Order Date', rowspan: 2 },
      { title: 'PO NO / PO Date', rowspan: 2 },
      { title: 'Profile No', rowspan: 2 },
      { title: 'Profile Image', rowspan: 2 },
      { title: 'Customer Reference Number', rowspan: 2 },
      { title: 'Length (mm)', rowspan: 2 },
      { title: 'Alloy Temper', rowspan: 2 },
      { title: 'Order', colspan: 2 },
      { title: 'Packed', colspan: 2 },
      { title: 'Warehouse', colspan: 2 },
      { title: 'Dispatched', colspan: 2 },
      { title: 'Pending', colspan: 2 },
      { title: 'Total KG', rowspan: 2 },
      { title: 'Remarks', rowspan: 2 },
    ];

    return `
      <thead>
        <tr>
          ${headers
        .map(
          h =>
            `<th ${h.colspan ? `colspan="${h.colspan}"` : ''} ${h.rowspan ? `rowspan="${h.rowspan}"` : ''
            } style="text-align: center">${h.title}</th>`,
        )
        .join('')}
        </tr>
        <tr>
          <th style="text-align: center">PCS</th><th style="text-align: center">KGS</th>
          <th style="text-align: center">PCS</th><th style="text-align: center">KGS</th>
          <th style="text-align: center">PCS</th><th style="text-align: center">KGS</th>
          <th style="text-align: center">PCS</th><th style="text-align: center">KGS</th>
          <th style="text-align: center">PCS</th><th style="text-align: center">KGS</th>
        </tr>
      </thead>
    `;
  };

  const generateTableBody = data => {
    const groupedData = groupData(data);
    let html = '<tbody>';
    let srNo = 1;

    Object.entries(groupedData).forEach(([customerName, orders]) => {
      const customerRowSpan = Object.values(orders).reduce(
        (sum, rows) => sum + rows.length,
        0,
      );
      let customerPrinted = false;

      Object.entries(orders).forEach(([orderKey, rows]) => {
        rows.forEach((row, idx) => {
          const fileExtension = row.profile_image
            ? row.profile_image.split('.').pop().toLowerCase()
            : '';
          const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(
            fileExtension,
          );
          const profileImage = row.profile_image?.startsWith('https://')
            ? isImage
              ? `<img src="${row.profile_image}" alt="Die Diagram" style="max-width:60px; max-height:40px; object-fit:contain;">`
              : `<a href="${row.profile_image}" target="_blank">View PDF</a>`
            : '';

          html += `<tr ${srNo % 2 === 0 ? 'style="background-color: #f9f9f9;"' : ''}>`;

          // Sr No: only for first row of each order group
          if (idx === 0) {
            html += `<td rowspan="${rows.length}" style="text-align: center">${srNo++}</td>`;
          }

          // Customer Name (only for 'die' filter)
          if (!customerPrinted && activeFilter === 'die') {
            html += `<td rowspan="${customerRowSpan}" style="text-align: center">${customerName}</td>`;
          }

          // Workorder No / Date (once per group)
          if (idx === 0) {
            html += `
            <td rowspan="${rows.length}" style="text-align: center">${row.workorder_no}</td>
            <td rowspan="${rows.length}" style="text-align: center">
              ${row.workorder_date ? dayjs(row.workorder_date).format('DD-MM-YYYY') : ''}
              ${row.po_no ? ' ' + row.po_no : ''}
            </td>
          `;
          }

          html += `
          <td style="text-align: center">${row.section || ''}</td>
          <td style="text-align: center">${profileImage}</td>
          <td style="text-align: center">${row.customer_reference_number || ''}</td>
          <td style="text-align: center">${row.length || ''}</td>
          <td style="text-align: center">${row.alloy_temper || ''}</td>
          <td style="text-align: center">${row.order_pcs || ''}</td>
          <td style="text-align: right">${row.order_kgs ? parseFloat(row.order_kgs).toFixed(2) : ''}</td>
          <td style="text-align: center">${row.packed_pcs || ''}</td>
          <td style="text-align: right">${row.packed_kgs ? parseFloat(row.packed_kgs).toFixed(2) : ''}</td>
          <td style="text-align: center">${row.warehouse_pcs || ''}</td>
          <td style="text-align: right">${row.warehouse_kgs ? parseFloat(row.warehouse_kgs).toFixed(2) : ''}</td>
          <td style="text-align: center">${row.dispatched_pcs || ''}</td>
          <td style="text-align: right">${row.dispatched_kgs ? parseFloat(row.dispatched_kgs).toFixed(2) : ''}</td>
          <td style="text-align: center">${row.pending_pcs || ''}</td>
          <td style="text-align: right">${row.pending_kgs ? parseFloat(row.pending_kgs).toFixed(2) : ''}</td>`;
          if (idx === 0) {
            html += `
            <td rowspan="${rows.length}" style="text-align: center">
            ${row.total_kgs ? parseFloat(row.total_kgs).toFixed(3) : ''}
            </td>
          `;
          }
          html += `

          <td style="text-align: center">${row.remark || ''}</td>
        </tr>`;

          if (!customerPrinted) customerPrinted = true;
        });
      });
    });

    html += '</tbody>';
    return html;
  };

  const generateTotalRow = totals => {
    return `
      <tfoot>
        <tr class="total-row">
          <td colspan="${activeFilter === 'die' ? 9 : 8
      }" style="text-align: center"><strong>Total</strong></td>
          <td style="text-align: center"><strong>${totals.order_pcs || ''}</strong></td>
          <td style="text-align: right"><strong>${totals.order_kgs ? parseFloat(totals.order_kgs).toFixed(2) : ''
      }</strong></td>
      <td style="text-align: center"><strong>${totals.packed_pcs || ''}</strong></td>
      <td style="text-align: right"><strong>${totals.packed_kgs ? parseFloat(totals.packed_kgs).toFixed(2) : ''
      }</strong></td>
      <td style="text-align: center"><strong>${totals.warehouse_pcs || ''
      }</strong></td>
      <td style="text-align: right"><strong>${totals.warehouse_kgs ? parseFloat(totals.warehouse_kgs).toFixed(2) : ''
      }</strong></td>
      <td style="text-align: center"><strong>${totals.dispatched_pcs || ''
      }</strong></td>
      <td style="text-align: right"><strong>${totals.dispatched_kgs
        ? parseFloat(totals.dispatched_kgs).toFixed(2)
        : ''
      }</strong></td>
          <td style="text-align: center"><strong>${totals.pending_pcs || ''
      }</strong></td>
          <td style="text-align: right"><strong>${totals.pending_kgs ? parseFloat(totals.pending_kgs).toFixed(2) : ''
      }</strong></td>
          <td></td>
        </tr>
      </tfoot>
    `;
  };

  const groupData = data => {
    return data.reduce((acc, row) => {
      const customerKey = row.customer_name || 'Unknown Customer';
      const workOrderKey = `${row.workorder_no}-${row.po_no || ''}`;

      if (!acc[customerKey]) {
        acc[customerKey] = {};
      }
      if (!acc[customerKey][workOrderKey]) {
        acc[customerKey][workOrderKey] = [];
      }

      acc[customerKey][workOrderKey].push(row);
      return acc;
    }, {});
  };

  const handlePrintDownloadAll = async () => {
    const count = totalRecord;
    if (count > 0) {
      try {
        setIsLoading(true); // Start Loading
        const response = await dispatch(
          fetchWorkOrderListByfilter({
            page: 1,
            pagesize: count,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();

        const workorderDetails = response?.results?.data;

        const filteredWorkorderDetails = (workorderDetails || []).filter(
          item => String(item.status).trim().toLowerCase() === 'open',
        );

        if (filteredWorkorderDetails.length > 0) {
          const createPDF = (includePrintText, pdfData) => {
            const pdf = new jsPDF('p', 'pt', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            pdf.addFileToVFS('WorkSans-normal.ttf', font);
            pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
            pdf.setFont('WorkSans');

            const pdfColumns = [
              { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
              {
                header: 'Order Date',
                dataKey: 'order_date',
                field: 'order_date',
              },
              { header: 'Order No', dataKey: 'order_no', field: 'order_no' },
              {
                header: 'PO No.',
                dataKey: 'purchase_order_no',
                field: 'purchase_order_no',
              },
              {
                header: 'Customer Name',
                dataKey: 'customer_name',
                field: 'customer_name',
              },
              {
                header: 'Total Weight',
                dataKey: 'total_weight',
                field: 'total_weight',
              },
              {
                header: 'Packed Weight',
                dataKey: 'total_packed_weight',
                field: 'total_packed_weight',
              },
              {
                header: 'Dispatched Weight',
                dataKey: 'total_dispatched_weight',
                field: 'total_dispatched_weight',
              },
              {
                header: 'Pending Weight',
                dataKey: 'total_pending_weight',
                field: 'total_pending_weight',
              },
              {
                header: 'Days Left',
                dataKey: 'days_left',
                field: 'days_left',
              },
              {
                header: 'Delivery Date',
                dataKey: 'delivery_date',
                field: 'delivery_date',
              },
              { header: 'Status', dataKey: 'status', field: 'status' },
              {
                header: 'Created At',
                dataKey: 'created_at',
                field: 'created_at',
              },
              {
                header: 'Created By',
                dataKey: 'created_by',
                field: 'created_by',
              },
              {
                header: 'Updated At',
                dataKey: 'updated_at',
                field: 'updated_at',
              },
              {
                header: 'Updated By',
                dataKey: 'updated_by',
                field: 'updated_by',
              },
            ];

            // Use checkedListDefault instead of checkedList
            const pdffilteredColumns = pdfColumns.filter(column =>
              checkedListDefault.includes(column.dataKey),
            );

            const getColorForDeliveryStatus = item => {
              const hasPlanningOrPacked =
                (item.status &&
                  ['closed'].includes(
                    String(item.status).trim().toLowerCase(),
                  )) ||
                item.work_order_details?.some(
                  el =>
                    el.status &&
                    ['closed'].includes(String(el.status).trim().toLowerCase()),
                );

              if (hasPlanningOrPacked) {
                return [153, 242, 163];
              }

              if (!item.order_date) return [255, 255, 255];

              const currentDate = dayjs();
              const orderDate = dayjs(item.order_date);
              const daysDiff = currentDate.diff(orderDate, 'day');

              if (daysDiff <= 0 || daysDiff <= 8) {
                return [255, 255, 255];
              } else if (daysDiff > 8 && daysDiff <= 12) {
                return [255, 255, 153];
              } else if (daysDiff > 12 && daysDiff <= 15) {
                return [255, 214, 153];
              } else {
                return [255, 179, 179];
              }
            };

            const getDaysLeftText = item => {
              const hasPlanningOrPacked =
                (item.status &&
                  ['closed'].includes(
                    String(item.status).trim().toLowerCase(),
                  )) ||
                item.work_order_details?.some(
                  el =>
                    el.status &&
                    ['closed'].includes(String(el.status).trim().toLowerCase()),
                );

              if (hasPlanningOrPacked) {
                return '-';
              }

              if (!item.order_date) return 'N/A';

              const currentDate = dayjs();
              const orderDate = dayjs(item.order_date);
              const daysDiff = currentDate.diff(orderDate, 'day');

              if (daysDiff === 0) {
                return 'Today';
              } else if (daysDiff < 0) {
                const absDiff = Math.abs(daysDiff);
                return absDiff === 1 ? '1 day left' : `${absDiff} days left`;
              } else {
                return daysDiff === 1 ? '1 day ago' : `${daysDiff} days ago`;
              }
            };

            const rows = pdfData.map((item, index) => {
              return {
                SrNo: index + 1,
                order_date: item?.order_date
                  ? dayjs(item.order_date).format('DD-MM-YYYY')
                  : 'N/A',
                order_no: item?.order_no || 'N/A',
                purchase_order_no: item?.purchase_order_no || 'N/A',
                customer_name: item?.customer_name || 'N/A',
                total_weight: item?.total_weight || 'N/A',
                total_packed_weight: item?.total_packed_weight ?? 'N/A',
                total_dispatched_weight: item?.total_dispatched_weight ?? '',
                total_pending_weight: item?.total_pending_weight ?? 'N/A',
                days_left: getDaysLeftText(item),
                delivery_date: item?.delivery_date
                  ? dayjs(item.delivery_date).format('DD-MM-YYYY')
                  : 'N/A',
                status: item?.status || 'N/A',
                created_at: item?.created_at
                  ? moment(item.created_at).format('DD-MM-YYYY')
                  : 'N/A',
                created_by: item?.created_by
                  ? `${item.created_by.first_name} ${item.created_by.last_name}`
                  : 'N/A',
                updated_at: item?.updated_at
                  ? moment(item.updated_at).format('DD-MM-YYYY')
                  : 'N/A',
                updated_by: item?.updated_by
                  ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
                  : 'N/A',
                _originalItem: item,
              };
            });

            pdf.text('WorkOrder', pdf.internal.pageSize.width / 2, 40, {
              align: 'center',
            });
            pdf.autoTable({
              head: [pdffilteredColumns.map(col => col.header)],
              body: rows.map(row =>
                pdffilteredColumns.map(col => row[col.dataKey]),
              ),
              startY: 65,
              theme: 'grid',
              styles: {
                font: 'times',
                halign: 'center',
                fontSize: 7,
                overflow: 'linebreak',
                cellPadding: 3.5,
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
              },
              headStyles: {
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                fillColor: false,
              },
              tableLineColor: [0, 0, 0],
              rowPageBreak: 'avoid',
              margin: { top: 65, left: 20, right: 20, bottom: 30 },
              didDrawCell: data => {
                const { row, column, cell } = data;
                const rowData = rows[row.index];

                if (rowData && rowData._originalItem) {
                  const columnKey = pdffilteredColumns[column.index]?.dataKey;

                  if (
                    columnKey === 'delivery_date' ||
                    columnKey === 'days_left'
                  ) {
                    const color = getColorForDeliveryStatus(
                      rowData._originalItem,
                    );

                    if (
                      color[0] !== 255 ||
                      color[1] !== 255 ||
                      color[2] !== 255
                    ) {
                      pdf.setFillColor(color[0], color[1], color[2]);
                      pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');

                      pdf.setDrawColor(0, 0, 0);
                      pdf.setLineWidth(0.5);
                      pdf.rect(cell.x, cell.y, cell.width, cell.height, 'S');

                      pdf.setTextColor(0, 0, 0);
                      pdf.setFontSize(7);
                      pdf.text(
                        cell.text,
                        cell.x + cell.width / 2,
                        cell.y + cell.height / 2,
                        {
                          align: 'center',
                          baseline: 'middle',
                        },
                      );
                    }
                  }
                }
              },
              didDrawPage: data => {
                const pageNumber = pdf.internal.getNumberOfPages();
                const str = `Page ${pageNumber}`;
                const dateStr = new Date().toLocaleString();
                pdf.setFontSize(10);
                pdf.text(dateStr, 40, pageHeight - 20);
                pdf.text(str, pageWidth - 60, pageHeight - 20);
                if (pageNumber === 1) {
                  pdf.addImage(companyLogo, 'PNG', pageWidth - 100, 10, 90, 30);
                }
              },
            });

            return pdf;
          };

          const printPDF = createPDF(true, filteredWorkorderDetails);
          const pdfBlob = printPDF.output('blob');

          const iframe = document.createElement('iframe');
          iframe.style.position = 'fixed';
          iframe.style.right = '0px';
          iframe.style.bottom = '0px';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.style.border = 'none';
          iframe.src = URL.createObjectURL(pdfBlob);

          document.body.appendChild(iframe);

          iframe.onload = () => {
            setIsLoading(false);
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          };
          dispatch(
            createActivityLog({
              action: 'PRINT',
              module_name: 'WorkOrder',
              ip_address: ipAddress,
              discription: 'WorkOrder print download successfully!',
            }),
          );
        } else {
          setIsLoading(false);
          console.warn('No work order details found.');
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Failed to fetch or generate PDF:', error);
      }
    }
  };
  

  const handleExcelExport = () => {
    try {

      let headers = null;
      if (activeFilter === 'customer') {
        headers = [
          'Sr. No.',
          'IWO No / Date',
          'PO No / Date',
          'Profile No',
          'Customer Reference Number',
          'Length (mm)',
          'Alloy / Temper',
          'Order PCS',
          'Order KGS',
          'Packed PCS',
          'Packed KGS',
          'Warehouse PCS',
          'Warehouse KGS',
          'Dispatched PCS',
          'Dispatched KGS',
          'Pending PCS',
          'Pending KGS',
          'Total KG',
          'Remarks',
        ];

        const dataRows = orderData?.map((order, index) => {
          const workOrderCell = `${order?.workorder_no || ''}${order?.order_date ? '\n' + dayjs(order?.order_date).format('DD-MM-YYYY') : ''}`;
          const poNoCell = `${order?.po_no || ''}${order?.po_date ? '\n' + dayjs(order.po_date).format('DD-MM-YYYY') : ''}`;
          const totalKgCell = `${order?.total_kgs ? parseFloat(order?.total_kgs).toFixed(3) : ''}`;

          return [
            index + 1,
            workOrderCell,
            poNoCell,
            order.section || 'N/A',
            order.customer_reference_number || '',
            Number(order.length) || 'N/A',
            order?.alloy_temper,
            Number(order.order_pcs) || '',
            order.order_kgs
              ? Number(parseFloat(order.order_kgs).toFixed(3))
              : 0,
            Number(order.packed_pcs) || '',
            order.packed_kgs
              ? Number(parseFloat(order.packed_kgs).toFixed(3))
              : 0,
            Number(order.warehouse_pcs) || '',
            order.warehouse_kgs
              ? Number(parseFloat(order.warehouse_kgs).toFixed(3))
              : 0,
            Number(order.dispatched_pcs) || '',
            order.dispatched_kgs
              ? Number(parseFloat(order.dispatched_kgs).toFixed(3))
              : 0,
            Number(order.pending_pcs) || '',
            order.pending_kgs
              ? Number(parseFloat(order.pending_kgs).toFixed(3))
              : 0,
            Number(totalKgCell),
            order.remark || '',
          ];
        });

        // Calculate totals for numeric columns
        const totalRow = [
          'TOTAL', // Sr. No.
          '', // Work Order No / Date
          '', // PO No / Date
          '', // Profile No
          '', // Customer Reference Number
          '', // Length (mm)
          '', // Alloy
          total_summary?.order_pcs, // Order PCS
          total_summary?.order_kgs?.toFixed(3), // Order KGS
          total_summary?.packed_pcs, // Packed PCS
          total_summary?.packed_kgs?.toFixed(3), // Packed KGS
          total_summary?.warehouse_pcs, // Warehouse PCS
          total_summary?.warehouse_kgs?.toFixed(3), // Warehouse KGS
          total_summary?.dispatched_pcs, // Dispatched PCS
          total_summary?.dispatched_kgs?.toFixed(3), // Dispatched KGS
          total_summary?.pending_pcs, // Pending PCS
          total_summary?.pending_kgs?.toFixed(3), // Pending KGS
          '', // Total Kg
          '', // Remarks
        ];

        // Combine headers, data rows, and total row
        const wsData = [headers, ...dataRows, totalRow];

        // Create a new workbook and worksheet
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Define merges array for cell merging
        const merges = [];

        // Group and merge logic for "Work Order No / Date" (column B, index 1)
        let workOrderStartRow = 1; // Start from row 1 (after header)
        for (let i = 1; i < dataRows.length; i++) {
          const currentWorkOrder = dataRows[i][1];
          const previousWorkOrder = dataRows[i - 1][1];
          if (currentWorkOrder !== previousWorkOrder) {
            if (i - workOrderStartRow > 0) {
              merges.push({
                s: { r: workOrderStartRow, c: 1 }, // Start row and column (B)
                e: { r: i, c: 1 }, // End row and column (B)
              });
            }
            workOrderStartRow = i + 1;
          }
        }
        // Handle the last group of Work Order
        if (dataRows.length - workOrderStartRow > 0) {
          merges.push({
            s: { r: workOrderStartRow, c: 1 },
            e: { r: dataRows.length, c: 1 },
          });
        }

        // Group and merge logic for "PO No / Date" (column C, index 2)
        let poNoStartRow = 1;
        for (let i = 1; i < dataRows.length; i++) {
          const currentPoNo = dataRows[i][2];
          const previousPoNo = dataRows[i - 1][2];
          const currentWorkOrder = dataRows[i][1];
          const previousWorkOrder = dataRows[i - 1][1];
          if (
            currentPoNo !== previousPoNo ||
            currentWorkOrder !== previousWorkOrder
          ) {
            if (i - poNoStartRow > 0) {
              merges.push({
                s: { r: poNoStartRow, c: 2 }, // Start row and column (C)
                e: { r: i, c: 2 }, // End row and column (C)
              });
            }
            poNoStartRow = i + 1;
          }
        }
        // Handle the last group of PO No
        if (dataRows.length - poNoStartRow > 0) {
          merges.push({
            s: { r: poNoStartRow, c: 2 },
            e: { r: dataRows.length, c: 2 },
          });
        }

        /* Total KG Cell Merge Logic */
        let totalKgStartRow = 1; // Start from first data row (after header)
        for (let i = 1; i < dataRows.length; i++) {
          const currentTotalKg = dataRows[i][17];
          const previousTotalKg = dataRows[i - 1][17];
          if (currentTotalKg !== previousTotalKg) {
            if (i - totalKgStartRow > 0) {
              merges.push({
                s: { r: totalKgStartRow, c: 17 }, // Start row and column (Q)
                e: { r: i, c: 17 }, // End row and column (Q)
              });
            }
            totalKgStartRow = i + 1;
          }
        }
        // Handle the last group of Total KG
        if (dataRows.length - totalKgStartRow >= 0) {
          merges.push({
            s: { r: totalKgStartRow, c: 17 },
            e: { r: dataRows.length, c: 17 },
          });
        }

        // Apply merges to the worksheet
        ws['!merges'] = merges;

        merges.forEach(merge => {
          const cellAddress = XLSX.utils.encode_cell({
            r: merge.s.r,
            c: merge.s.c,
          });

          if (ws[cellAddress]) {
            ws[cellAddress].s = {
              alignment: {
                vertical: 'center',
                horizontal: 'center',
                wrapText: true,
              },
            };
          }
        });

        // Adjust column widths
        ws['!cols'] = [
          { wch: 10 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 }, // Profile No
          { wch: 20 }, // Customer Reference Number
          { wch: 15 }, // Length (mm)
          { wch: 10 }, // Order PCS
          { wch: 10 }, // Order KGS
          { wch: 10 }, // Dispatched PCS
          { wch: 10 }, // Dispatched KGS
          { wch: 10 }, // Packed PCS
          { wch: 10 }, // Packed KGS
          { wch: 10 }, // Warehouse PCS
          { wch: 10 }, // Warehouse KGS
          { wch: 10 }, // Pending PCS
          { wch: 10 }, // Pending KGS
          { wch: 15 }, // Remarks
        ];

        // // Apply middle alignment (vertical and horizontal) to all cells

        for (let row = 0; row < wsData.length; row++) {
          for (let col = 0; col < headers.length; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            if (!ws[cellAddress]) continue;
            const isNumericColumn = [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
            ].includes(col);
            const isCenterColumn = [1, 2, 16, 17].includes(col); // Example: Work Order, PO, Total KG, Remarks

            ws[cellAddress].s = {
              alignment: {
                vertical: 'center',
                horizontal: isCenterColumn
                  ? 'center'
                  : isNumericColumn
                    ? 'right'
                    : 'left',
                wrapText: true,
              },
            };
          }
        }

        // Create a workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Work Order Report');

        // Generate the Excel file and trigger download
        XLSX.writeFile(
          wb,
          `${orderData ? orderData[0]?.customer_name : ''}_Work_Order_Report.xlsx`,
        );
      } else if (activeFilter === 'die') {
        const sortedData = [...orderData].sort((a, b) => {
          return (
            a.customer_name.localeCompare(b.customer_name) ||
            a.workorder_no.localeCompare(b.workorder_no) ||
            a.po_no.localeCompare(b.po_no)
          );
        });

        // Calculate spans for customer_name
        const customerSpanMap = {};
        sortedData.forEach((item, index) => {
          const name = item.customer_name;
          if (!customerSpanMap[name]) {
            customerSpanMap[name] = {
              count: 1,
              firstIndex: index,
            };
          } else {
            customerSpanMap[name].count++;
          }
        });

        // Calculate spans for workorder_no and po_no
        const workOrderSpanMap = {};
        const poNoSpanMap = {};
        sortedData.forEach((item, index) => {
          // Work Order grouping
          const isWorkOrderRepeated =
            index > 0 &&
            sortedData[index - 1].workorder_no === item.workorder_no;
          if (!isWorkOrderRepeated) {
            let count = 1;
            for (let i = index + 1; i < sortedData.length; i++) {
              if (sortedData[i].workorder_no === item.workorder_no) {
                count++;
              } else {
                break;
              }
            }
            workOrderSpanMap[item.workorder_no] = {
              count,
              firstIndex: index,
            };
          }

          // PO Number grouping
          const isPoNoRepeated =
            index > 0 &&
            sortedData[index - 1].workorder_no === item.workorder_no &&
            sortedData[index - 1].po_no === item.po_no;
          if (!isPoNoRepeated) {
            let count = 1;
            for (let i = index + 1; i < sortedData.length; i++) {
              if (
                sortedData[i].workorder_no === item.workorder_no &&
                sortedData[i].po_no === item.po_no
              ) {
                count++;
              } else {
                break;
              }
            }
            poNoSpanMap[`${item.workorder_no}|${item.po_no}`] = {
              count,
              firstIndex: index,
            };
          }
        });

        const wb = XLSX.utils.book_new();

        const wsData = [];

        const headers = [
          'Sr. No.',
          'Customer Name',
          'Work Order No / Date',
          'PO No / Date',
          'Profile No',
          'Customer Reference Number',
          'Length (mm)',
          'Order PCS',
          'Order KGS',
          'Dispatched PCS',
          'Dispatched KGS',
          'Packed PCS',
          'Packed KGS',
          'Warehouse PCS',
          'Warehouse KGS',
          'Pending PCS',
          'Pending KGS',
          'Total KG',
          'Remarks',
        ];

        wsData.push(headers);

        sortedData.forEach((order, index) => {
          const customerSpanInfo = customerSpanMap[order.customer_name];
          const showCustomerCell = customerSpanInfo.firstIndex === index;

          const isWorkOrderRepeated =
            index > 0 &&
            sortedData[index - 1].workorder_no === order.workorder_no;
          const workOrderCell = isWorkOrderRepeated
            ? ''
            : `${order.workorder_no || ''}${order.order_date ? '\n' + dayjs(order.order_date).format('DD-MM-YYYY') : ''}`;

          const isPoNoRepeated =
            index > 0 &&
            sortedData[index - 1].workorder_no === order.workorder_no &&
            sortedData[index - 1].po_no === order.po_no;
          const poNoCell = isPoNoRepeated
            ? ''
            : `${order.po_no || ''}${order.po_date ? '\n' + dayjs(order.po_date).format('DD-MM-YYYY') : ''}`;

          const totalKgCell = `${order.total_kgs ? parseFloat(order.total_kgs).toFixed(3) : ''}`;

          const row = [
            index + 1,
            showCustomerCell ? order.customer_name || '' : '',
            workOrderCell,
            poNoCell,
            order.section || 'N/A',
            order.customer_reference_number || '',
            order.length || 'N/A',
            Number(order.order_pcs) || '',
            order.order_kgs
              ? Number(parseFloat(order.order_kgs).toFixed(3))
              : '',
            Number(order.dispatched_pcs) || '',
            order.dispatched_kgs
              ? Number(parseFloat(order.dispatched_kgs).toFixed(3))
              : '',
            Number(order.packed_pcs) || '',
            order.packed_kgs
              ? Number(parseFloat(order.packed_kgs).toFixed(3))
              : '',
            Number(order.warehouse_pcs) || '',
            order.warehouse_kgs
              ? Number(parseFloat(order.warehouse_kgs).toFixed(3))
              : '',
            Number(order.pending_pcs) || '',
            order.pending_kgs
              ? Number(parseFloat(order.pending_kgs).toFixed(3))
              : '',
            Number(totalKgCell),
            order.remark || '',
          ];

          wsData.push(row);
        });

        if (sortedData.length > 0) {
          const totalRow = [
            '',
            '',
            '',
            '',
            '',
            '',
            'TOTAL',
            sortedData.reduce(
              (sum, order) => sum + (parseInt(order.order_pcs) || 0),
              0,
            ),
            sortedData
              .reduce(
                (sum, order) => sum + (parseFloat(order.order_kgs) || 0),
                0,
              )
              .toFixed(3),
            sortedData.reduce(
              (sum, order) => sum + (parseInt(order.dispatched_pcs) || 0),
              0,
            ),
            sortedData
              .reduce(
                (sum, order) => sum + (parseFloat(order.dispatched_kgs) || 0),
                0,
              )
              .toFixed(3),
            sortedData.reduce(
              (sum, order) => sum + (parseInt(order.packed_pcs) || 0),
              0,
            ),
            sortedData
              .reduce(
                (sum, order) => sum + (parseFloat(order.packed_kgs) || 0),
                0,
              )
              .toFixed(3),
            sortedData.reduce(
              (sum, order) => sum + (parseInt(order.warehouse_pcs) || 0),
              0,
            ),
            sortedData
              .reduce(
                (sum, order) => sum + (parseFloat(order.warehouse_kgs) || 0),
                0,
              )
              .toFixed(3),
            sortedData.reduce(
              (sum, order) => sum + (parseInt(order.pending_pcs) || 0),
              0,
            ),
            sortedData
              .reduce(
                (sum, order) => sum + (parseFloat(order.pending_kgs) || 0),
                0,
              )
              .toFixed(3),
            '',
          ];

          wsData.push(totalRow);
        }

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        const merges = [];

        // Merge cells for customer_name
        Object.entries(customerSpanMap).forEach(([customerName, spanInfo]) => {
          if (spanInfo.count > 1) {
            const startRow = spanInfo.firstIndex + 1;
            const endRow = startRow + spanInfo.count - 1;
            merges.push({
              s: { r: startRow, c: 1 },
              e: { r: endRow, c: 1 },
            });
          }
        });

        // Merge cells for workorder_no
        Object.entries(workOrderSpanMap).forEach(([workOrderNo, spanInfo]) => {
          if (spanInfo.count > 1) {
            const startRow = spanInfo.firstIndex + 1;
            const endRow = startRow + spanInfo.count - 1;
            merges.push({
              s: { r: startRow, c: 2 },
              e: { r: endRow, c: 2 },
            });
          }
        });

        // Merge cells for po_no
        Object.entries(poNoSpanMap).forEach(([key, spanInfo]) => {
          if (spanInfo.count > 1) {
            const startRow = spanInfo.firstIndex + 1;
            const endRow = startRow + spanInfo.count - 1;
            merges.push({
              s: { r: startRow, c: 3 },
              e: { r: endRow, c: 3 },
            });
          }
        });

        ws['!merges'] = merges;

        const colWidths = [
          { wch: 8 },
          { wch: 20 },
          { wch: 18 },
          { wch: 15 },
          { wch: 12 },
          { wch: 20 },
          { wch: 12 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 12 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 12 },
          { wch: 10 },
          { wch: 10 },
          { wch: 15 },
        ];

        ws['!cols'] = colWidths;

        const borderStyle = {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
        };

        const headerStyle = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '4F81BD' } },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: borderStyle,
        };

        for (let col = 0; col < headers.length; col++) {
          const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
          if (!ws[cellRef]) ws[cellRef] = { t: 's', v: headers[col] };
          ws[cellRef].s = headerStyle;
        }

        for (
          let row = 1;
          row < wsData.length - (sortedData.length > 0 ? 1 : 0);
          row++
        ) {
          for (let col = 0; col < headers.length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
            const cellStyle = {
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true, // Enable wrap text for workorder_no and po_no cells with newlines
              },
              border: borderStyle,
            };

            if (ws[cellRef]) {
              ws[cellRef].s = cellStyle;
            } else {
              ws[cellRef] = { t: 's', v: '', s: cellStyle };
            }
          }
        }

        if (sortedData.length > 0) {
          const totalRowIndex = wsData.length - 1;
          for (let col = 0; col < headers.length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: totalRowIndex, c: col });
            const totalRowStyle = {
              font: { bold: true },
              fill: { fgColor: { rgb: 'E7E6E6' } },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
              border: borderStyle,
            };

            if (ws[cellRef]) {
              ws[cellRef].s = totalRowStyle;
            }
          }
        }

        XLSX.utils.book_append_sheet(wb, ws, 'WorkOrder Report');

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute(
          'download',
          `Work_Order_Report_${sortedData[0]?.section || 'Profile'}_${dayjs().format('DD-MM-YYYY')}.xlsx`,
        );
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        headers = [
          'Sr. No.',
          'Order Date',
          'Order No.',
          'PO No.',
          'Customer Name',
          'Total Weight',
          'Total Packed Weight',
          'Total Pending Weight',
          'Total Dispatched Weight',
          'Days',
          'Delivery Date',
          'Status',
        ];
        const getDaysLeftText = item => {
          const hasPlanningOrPacked =
            (item.status &&
              ['closed'].includes(String(item.status).trim().toLowerCase())) ||
            item.work_order_details?.some(
              el =>
                el.status &&
                ['closed'].includes(String(el.status).trim().toLowerCase()),
            );

          if (hasPlanningOrPacked) {
            return '-';
          }

          if (!item.order_date) return 'N/A';

          const currentDate = dayjs();
          const orderDate = dayjs(item.order_date);
          const daysDiff = currentDate.diff(orderDate, 'day');

          if (daysDiff === 0) {
            return 'Today';
          } else if (daysDiff < 0) {
            const absDiff = Math.abs(daysDiff);
            return absDiff === 1 ? '1 day left' : `${absDiff} days left`;
          } else {
            return daysDiff === 1 ? '1 day ago' : `${daysDiff} days ago`;
          }
        };
        const filteredData = data
          ?.filter(item => item.status === 'Open')
          .map((item, index) => ({
            'Sr. No.': index + 1,
            'Order Date': item.order_date
              ? dayjs(item.order_date).format('DD-MM-YYYY')
              : '' || '',
            'Order No.': item.order_no || 'N/A',
            'PO No.': item.purchase_order_no || 'N/A',
            'Customer Name': item.customer_name || 'N/A',
            'Total Weight': item.total_weight || 0,
            'Total Packed Weight': item.total_packed_weight || 0,
            'Total Pending Weight': item.total_pending_weight || 0,
            'Total Dispatched Weight': item.total_dispatched_weight || 0,
            'Days Left': getDaysLeftText(item) || '',
            'Delivery Date': item.delivery_date
              ? dayjs(item.delivery_date).format('DD-MM-YYYY')
              : '' || '',
            Status: item.status || '',
          }));

        // Convert JSON to worksheet
        const ws = XLSX.utils.json_to_sheet(filteredData);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Work Order Report');

        // Write file and trigger download
        XLSX.writeFile(wb, 'Open_Work_Order_Report.xlsx');
      }
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      message.error('Failed to export Excel file');
    }
  };

  const handleButtonClick = () => {
    if (!activeFilter) {
      handlePrintDownloadAll();
    } else {
      handlePrint();
    }
  };
 

  const handleEdit = record => {
    navigate(`/edit-work-order/${record.id}`);
  };

  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteWorkOrder(id))
      .unwrap()
      .then(() => {
        message.success('Work Order Archived Successfully!');
        fetchWorkOrders({ page, pagesize, search, orderBy });
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error)
            if (Array.isArray(error[key]))
              messages.push(`${key}: ${error[key].join(', ')}`);
          messages.length > 0
            ? message.error(messages.join('; '))
            : message.error('An unknown error occurred.');
        } else if (typeof error === 'string') message.error(error);
        else if (error instanceof Error) message.error(error.message);
        else message.error('An unknown error occurred.');
      });
  };
  const [checkedListDefault, setCheckedListDefault] = useState([
    'SrNo',
    'order_date',
    'order_no',
    'purchase_order_no',
    'customer_name',
    'total_weight',
    'total_packed_weight',
    'total_pending_weight',
    'total_dispatched_weight',
    'days_left',
    'delivery_date',
    'workorder_type',
    'status',
    'action',
  ]);

  const [checkedListCustomer, setCheckedListCustomer] = useState([
    'sr_no',
    'workorder_no',
    'po_no',
    'section',
    'profile_image',
    'customer_reference_number',
    'length',
    'alloy_temper',
    'order_pcs',
    'order_kgs',
    'dispatched_pcs',
    'dispatched_kgs',
    'packed_pcs',
    'packed_kgs',
    'warehouse_pcs',
    'warehouse_kgs',
    'pending_pcs',
    'pending_kgs',
    'total_kgs',
    'remark',
  ]);

  const [checkedListDie, setCheckedListDie] = useState([
    'sr_no',
    'customer_name',
    'workorder_no',
    'po_no',
    'section',
    'profile_image',
    'customer_reference_number',
    'length',
    'alloy_temper',
    'order_pcs',
    'order_kgs',
    'dispatched_pcs',
    'dispatched_kgs',
    'packed_pcs',
    'packed_kgs',
    'warehouse_pcs',
    'warehouse_kgs',
    'pending_pcs',
    'pending_kgs',
    'remark',
  ]);

  function filterColumnsWithChildren(columns, checkedList) {
    return columns.reduce((acc, col) => {
      if (col.children) {
        const filteredChildren = filterColumnsWithChildren(
          col.children,
          checkedList,
        );
        if (filteredChildren.length > 0) {
          acc.push({ ...col, children: filteredChildren });
        }
      } else if (checkedList.includes(col.dataIndex)) {
        acc.push(col);
      }
      return acc;
    }, []);
  }

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      align: 'center',
      width: 100,
      render: (text, record, index) => {
        return (page - 1) * pagesize + index + 1;
      },
    },
    {
      title: 'Order Date',
      dataIndex: 'order_date',
      key: 'order_date',
      align: 'center',
      render: order_date => {
        return (
          <span>
            {order_date ? dayjs(order_date).format('DD-MM-YYYY') : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Order No.',
      dataIndex: 'order_no',
      key: 'order_no',
      align: 'center',
      render: order_no => {
        return <span>{order_no || 'N/A'}</span>;
      },
    },
    {
      title: 'PO No.',
      dataIndex: 'purchase_order_no',
      key: 'purchase_order_no',
      width: '10%',
      align: 'center',
      render: purchase_order_no => {
        return <span>{purchase_order_no || 'N/A'}</span>;
      },
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      align: 'center',
      render: customer_name => {
        return <span>{customer_name || 'N/A'}</span>;
      },
      key: 'customer_name',
    },
    {
      title: 'Total Weight',
      dataIndex: 'total_weight',
      key: 'total_weight',
      align: 'center',
      render: total_weight => {
        return <span>{total_weight ? total_weight : ''}</span>;
      },
    },
    {
      title: 'Packed Weight',
      dataIndex: 'total_packed_weight',
      key: 'total_packed_weight',
      align: 'center',
      render: total_packed_weight => {
        return (
          <span>
            {total_packed_weight ? total_packed_weight : ''}
          </span>
        );
      },
    },
    {
      title: 'Dispatched Weight',
      dataIndex: 'total_dispatched_weight',
      key: 'total_dispatched_weight',
      width: '5%',
      align: 'center',
      render: total_dispatched_weight => {
        return (
          <span>
            {total_dispatched_weight ? total_dispatched_weight : ''}
          </span>
        );
      },
    },
    {
      title: 'Pending Weight',
      dataIndex: 'total_pending_weight',
      key: 'total_pending_weight',
      align: 'center',
      render: total_pending_weight => {
        return (
          <span>
            {total_pending_weight ? total_pending_weight : ''}
          </span>
        );
      },
    },
    {
      title: 'Days',
      dataIndex: 'days_left',
      key: 'days_left',
      align: 'center',
      render: (text, record) => {
        const hasPlanningOrPacked =
          (record.status &&
            ['closed'].includes(String(record.status).trim().toLowerCase())) ||
          record.work_order_details?.some(
            el =>
              el.status &&
              ['closed'].includes(String(el.status).trim().toLowerCase()),
          );

        if (hasPlanningOrPacked) {
          return (
            <span
              style={{
                backgroundColor: '#99f2a3',
                color: 'black',
                textAlign: 'center',
                padding: '2px 6px',
                borderRadius: '4px',
                display: 'inline-block',
                minWidth: '50px',
              }}
            >
              -
            </span>
          );
        }

        if (!record.order_date) return <span>N/A</span>;

        const currentDate = dayjs();
        const orderDate = dayjs(record.order_date);
        const daysDiff = currentDate.diff(orderDate, 'day');

        let textColor = 'black';
        let backgroundColor = undefined;

        if (daysDiff <= 0) {
          backgroundColor = undefined;
        } else if (daysDiff <= 8) {
          backgroundColor = undefined;
        } else if (daysDiff > 8 && daysDiff <= 12) {
          backgroundColor = '#ffff99';
        } else if (daysDiff > 12 && daysDiff <= 15) {
          backgroundColor = '#ffd699';
        } else {
          backgroundColor = '#ffb3b3';
        }

        let displayText;
        if (daysDiff === 0) {
          displayText = 'Today';
        } else if (daysDiff < 0) {
          const absDiff = Math.abs(daysDiff);
          displayText = absDiff === 1 ? '1 day left' : `${absDiff} days left`;
        } else {
          displayText = daysDiff === 1 ? '1 day ago' : `${daysDiff} days ago`;
        }

        return (
          <span
            style={{
              textAlign: 'center',
              backgroundColor: backgroundColor,
              color: textColor,
              padding: '2px 6px',
              borderRadius: '4px',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {displayText}
          </span>
        );
      },
    },
    {
      title: 'Delivery Date',
      dataIndex: 'delivery_date',
      key: 'delivery_date',
      align: 'center',
      render: (delivery_date, record) => {
        if (!delivery_date) return <span>N/A</span>;

        const hasPlanningOrPacked =
          (record.status &&
            ['closed'].includes(String(record.status).trim().toLowerCase())) ||
          record.work_order_details?.some(
            el =>
              el.status &&
              ['closed'].includes(String(el.status).trim().toLowerCase()),
          );

        if (hasPlanningOrPacked) {
          return (
            <span
              style={{
                backgroundColor: '#99f2a3',
                color: 'black',
                textAlign: 'center',
                padding: '2px 6px',
                borderRadius: '4px',
                display: 'inline-block',
                minWidth: '90px',
              }}
            >
              {dayjs(delivery_date).format('DD-MM-YYYY')}
            </span>
          );
        }

        const currentDate = dayjs();
        const orderDate = dayjs(record.order_date);
        const daysDiff = currentDate.diff(orderDate, 'day');

        let textColor = 'black';
        let backgroundColor = undefined;

        if (daysDiff <= 0) {
          backgroundColor = undefined;
        } else if (daysDiff <= 8) {
          backgroundColor = undefined;
        } else if (daysDiff > 8 && daysDiff <= 12) {
          backgroundColor = '#ffff99';
        } else if (daysDiff > 12 && daysDiff <= 15) {
          backgroundColor = '#ffd699';
        } else {
          backgroundColor = '#ffb3b3';
        }

        return (
          <span
            style={{
              textAlign: 'center',
              backgroundColor: backgroundColor,
              color: textColor,
              padding: '2px 6px',
              borderRadius: '4px',
              display: 'inline-block',
              minWidth: '90px',
            }}
          >
            {dayjs(delivery_date).format('DD-MM-YYYY')}
          </span>
        );
      },
    },
    {
      title: 'Work Order Type',
      dataIndex: 'workorder_type',
      key: 'workorder_type',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      align: 'center',
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      align: 'center',
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      align: 'center',
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 150,
      render: (text, record, index) => (
        <Space>
          {currentUser.permissions.permissions.workorder.includes(
            'print_workorder_copy',
          ) && (
              <>
                <Tooltip title="View">
                  <Link to={`/view-work-order-list/${record?.id}`}>
                    <ViewIcon />
                  </Link>
                </Tooltip>
                <a
                  href={`/print-work-order/${record.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="Print">
                    <PlanPrintIcon />
                  </Tooltip>
                </a>
              </>
            )}
          {currentUser.permissions.permissions.workorder.includes(
            'change_workorder',
          ) && (
              <Tooltip placement="top" title={'Edit'}>
                <span
                  onClick={() => handleEdit(record)}
                  style={{ cursor: 'pointer' }}
                >
                  <EditIcon />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.workorder.includes(
            'delete_workorder',
          ) &&
            record?.workorder_type !== 'Job Work' && (
              <Tooltip title="Archive">
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => handleDelete(record.id)}
                  onCancel={() => message.info('Action cancelled')}
                  okText="Yes"
                  cancelText="No"
                >
                  <Link>
                    <Archive />
                  </Link>
                </Popconfirm>
              </Tooltip>
            )}
        </Space>
      ),
    },
  ];

  const customerViewColumns = [
    {
      title: 'Sr. No.',
      dataIndex: 'sr_no',
      key: 'sr_no',
      render: (text, record, index) => index + 1,
      width: '3.5%',
      align: 'center',
    },
    {
      title: (
        <>
          IWO No / <br /> Date
        </>
      ),
      dataIndex: 'workorder_no',
      key: 'workorder_no',
      width: '7%',
      align: 'center',
      render: (value, row) => {
        const rowSpan = row.workorder_rowSpan;

        return {
          children: (
            <>
              {value}
              {row.workorder_date && (
                <>
                  <br />
                  {' / '}
                  {dayjs(row.workorder_date).format('DD-MM-YYYY')}
                </>
              )}
            </>
          ),
          props: { rowSpan },
        };
      },
    },
    {
      title: (
        <>
          PO NO / <br /> Date
        </>
      ),
      dataIndex: 'po_no',
      key: 'po_no',
      width: '6%',
      align: 'center',
      render: (value, row) => {
        const rowSpan = row.po_rowSpan;
        return {
          children: value,
          props: { rowSpan },
        };
      },
    },
    {
      title: 'Profile No',
      dataIndex: 'section',
      key: 'section',
      width: '6%',
      align: 'center',
    },
    {
      title: 'Profile Image',
      dataIndex: 'profile_image',
      key: 'profile_image',
      width: '7%',
      align: 'center',
      render: profile_image => {
        const fileUrl = profile_image;
        const imageContainerStyle = {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '4px',
          overflow: 'hidden',
        };
        const imageStyle = {
          width: '90px',
          height: '90px',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          display: 'block',
        };
        if (!fileUrl) {
          return (
            <div style={imageContainerStyle}>
              <span style={{ fontSize: '12px', color: '#999' }}>N/A</span>
            </div>
          );
        }
        const fileExtension = fileUrl.split('.').pop().toLowerCase();
        if (fileExtension === 'pdf') {
          return (
            <Button
              type="link"
              style={{ padding: '0px' }}
              onClick={async () => {
                const response = await fetch(fileUrl);
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const blobData = await response.blob();
                const blob = new Blob([blobData], { type: 'application/pdf' });
                const blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
              }}
            >
              View PDF
            </Button>
          );
        } else if (
          ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)
        ) {
          return (
            <div style={imageContainerStyle}>
              <img src={fileUrl} alt="Die Diagram" style={imageStyle} />
            </div>
          );
        } else {
          return (
            <div style={imageContainerStyle}>
              <span style={{ fontSize: '12px', color: '#999' }}>Unsupported</span>
            </div>
          );
        }
      },
    },
    {
      title: (
        <>
          Customer <br />
          Ref No
        </>
      ),
      dataIndex: 'customer_reference_number',
      key: 'customer_reference_number',
      width: '7%',
      align: 'center',
    },
    {
      title: (
        <>
          Length <br />
          (mm)
        </>
      ),
      dataIndex: 'length',
      key: 'length',
      width: '6%',
      align: 'center',
    },
    {
      title: (
        <>
          Alloy <br />
          Temper
        </>
      ),
      dataIndex: 'alloy_temper',
      key: 'alloy_temper',
      width: '6%',
      align: 'center',
    },
    {
      title: 'Order',
      children: [
        {
          title: 'PCS',
          dataIndex: 'order_pcs',
          key: 'order_pcs',
          width: '4%',
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'order_kgs',
          key: 'order_kgs',
          width: '6%',
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Packed',
      children: [
        {
          title: 'PCS',
          dataIndex: 'packed_pcs',
          key: 'packed_pcs',
          width: '4%',
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'packed_kgs',
          key: 'packed_kgs',
          width: '6%',
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Warehouse',
      children: [
        {
          title: 'PCS',
          dataIndex: 'warehouse_pcs',
          key: 'warehouse_pcs',
          width: '4%',
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'warehouse_kgs',
          key: 'warehouse_kgs',
          width: '6%',
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Dispatched',
      children: [
        {
          title: 'PCS',
          dataIndex: 'dispatched_pcs',
          key: 'dispatched_pcs',
          width: '4%',
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'dispatched_kgs',
          key: 'dispatched_kgs',
          width: '6%',
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Pending',
      children: [
        {
          title: 'PCS',
          dataIndex: 'pending_pcs',
          key: 'pending_pcs',
          width: '4%',
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'pending_kgs',
          key: 'pending_kgs',
          width: '6%',
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Total KG',
      dataIndex: 'total_kgs',
      key: 'total_kgs',
      width: '5%',
      ellipsis: true,
      render: (value, row) => {
        const rowSpan = row.totalKg_rowSpan;

        return {
          children: <>{value}</>,
          props: { rowSpan },
        };
      },
    },
    {
      title: 'Remarks',
      dataIndex: 'remark',
      key: 'remark',
      width: '5%',
      ellipsis: true,
      render: text => (
        <Tooltip title={text}>
          <span style={{ whiteSpace: 'pre-wrap' }}>{text || ''}</span>
        </Tooltip>
      ),
    },
  ];

  const profileViewColumns = [
    {
      title: 'Sr. No.',
      dataIndex: 'sr_no',
      key: 'sr_no',
      render: (text, record, index) => index + 1,
      width: '60px',
      align: 'center',
    },
    {
      title: (
        <>
          Customer <br /> Name{' '}
        </>
      ),
      dataIndex: 'customer_name',
      key: 'customer_name',
      align: 'center',
      width: '110px',
      render: (value, row) => {
        const rowSpan = row.customer_rowSpan;

        return {
          children: value || '',
          props: { rowSpan },
        };
      },
    },
    {
      title: (
        <>
          IWO No /<br /> Date
        </>
      ),
      dataIndex: 'workorder_no',
      key: 'workorder_no',
      align: 'center',
      width: '100px',
      render: (value, row) => {
        const rowSpan = row.workorder_rowSpan;

        return {
          children: (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {value}
              {row.workorder_date && (
                <>
                  {' / '}
                  <br />
                  {dayjs(row.workorder_date).format('DD-MM-YYYY')}
                </>
              )}
            </div>
          ),
          props: { rowSpan },
        };
      },
    },
    {
      title: 'PO NO / Date',
      dataIndex: 'po_no',
      key: 'po_no',
      align: 'center',
      width: 110,
      render: (value, row) => {
        const rowSpan = row.po_rowSpan;
        return {
          children: value,
          props: { rowSpan },
        };
      },
    },
    {
      title: 'Profile No',
      dataIndex: 'section',
      key: 'section',
      align: 'center',
      width: '100px',
    },
    {
      title: 'Profile Image',
      dataIndex: 'profile_image',
      key: 'profile_image',
      align: 'center',
      width: '115px',
      render: profile_image => {
        const fileUrl = profile_image;
        const imageContainerStyle = {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '4px',
          overflow: 'hidden',
        };
        const imageStyle = {
          width: '90px',
          height: '90px',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          display: 'block',
        };
        if (!fileUrl) {
          return (
            <div style={imageContainerStyle}>
              <span style={{ fontSize: '12px', color: '#999' }}>N/A</span>
            </div>
          );
        }
        const fileExtension = fileUrl.split('.').pop().toLowerCase();
        if (fileExtension === 'pdf') {
          return (
            <Button
              type="link"
              style={{ padding: '0px' }}
              onClick={async () => {
                const response = await fetch(fileUrl);
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const blobData = await response.blob();
                const blob = new Blob([blobData], { type: 'application/pdf' });
                const blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
              }}
            >
              View PDF
            </Button>
          );
        } else if (
          ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)
        ) {
          return (
            <div style={imageContainerStyle}>
              <img src={fileUrl} alt="Die Diagram" style={imageStyle} />
            </div>
          );
        } else {
          return (
            <div style={imageContainerStyle}>
              <span style={{ fontSize: '12px', color: '#999' }}>Unsupported</span>
            </div>
          );
        }
      },
    },
    {
      title: (
        <>
          Customer <br /> Ref No
        </>
      ),
      dataIndex: 'customer_reference_number',
      key: 'customer_reference_number',
      align: 'center',
      width: '100px',
    },
    {
      title: (
        <>
          Length <br />
          (mm)
        </>
      ),
      dataIndex: 'length',
      key: 'length',
      align: 'center',
      width: 100,
    },
    {
      title: (
        <>
          Alloy <br />
          Temper
        </>
      ),
      dataIndex: 'alloy_temper',
      key: 'alloy_temper',
      width: 100,
      align: 'center',
    },
    {
      title: 'Order',
      children: [
        {
          title: 'PCS',
          dataIndex: 'order_pcs',
          key: 'order_pcs',
          width: 70,
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'order_kgs',
          key: 'order_kgs',
          width: 70,
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Packed',
      children: [
        {
          title: 'PCS',
          dataIndex: 'packed_pcs',
          key: 'packed_pcs',
          width: 70,
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'packed_kgs',
          key: 'packed_kgs',
          width: 70,
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Warehouse',
      children: [
        {
          title: 'PCS',
          dataIndex: 'warehouse_pcs',
          key: 'warehouse_pcs',
          width: 70,
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'warehouse_kgs',
          key: 'warehouse_kgs',
          width: 70,
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Dispatched',
      children: [
        {
          title: 'PCS',
          dataIndex: 'dispatched_pcs',
          key: 'dispatched_pcs',
          width: 70,
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'dispatched_kgs',
          key: 'dispatched_kgs',
          width: 70,
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Pending',
      children: [
        {
          title: 'PCS',
          dataIndex: 'pending_pcs',
          key: 'pending_pcs',
          width: 70,
          align: 'center',
          render: value => (value ? value : ''),
        },
        {
          title: 'KGS',
          dataIndex: 'pending_kgs',
          key: 'pending_kgs',
          width: 70,
          align: 'right',
          render: value => (value ? parseFloat(value) : ''),
        },
      ],
    },
    {
      title: 'Remarks',
      dataIndex: 'remark',
      key: 'remark',
      align: 'center',
      width: 140,
      ellipsis: true,
      render: text => (
        <Tooltip title={text}>
          <span>{text || ''}</span>
        </Tooltip>
      ),
    },
  ];

  const handleColumnVisibilityChange = checkedValues => {
    if (activeFilter === 'customer') {
      setCheckedListCustomer(checkedValues);
    } else if (activeFilter === 'die') {
      setCheckedListDie(checkedValues);
    } else {
      setCheckedListDefault(checkedValues);
    }
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={
            activeFilter === 'customer'
              ? checkedListCustomer
              : activeFilter === 'die'
                ? checkedListDie :
                checkedListDefault
          }
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            {columns.map(col => (
              <Col xs={12} md={12} key={col.key}>
                <Checkbox value={col.dataIndex} disabled={col.key === 'SrNo' || col.key === 'action'}>
                  {col.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const GetSortingEnumValue = (sortField, sortOrder) => {
    const sortMap = {
      SrNo: { ascend: 'SrNo', descend: '-SrNo' },
      customer_name: { ascend: 'customer_name', descend: '-customer_name' },
      workorder_no: { ascend: 'workorder_no', descend: '-workorder_no' },
      workorder_date: { ascend: 'workorder_date', descend: '-workorder_date' },
      section: { ascend: 'section', descend: '-section' },
      length: { ascend: 'length', descend: '-length' },
      order_pcs: { ascend: 'order_pcs', descend: '-order_pcs' },
      order_kgs: { ascend: 'order_kgs', descend: '-order_kgs' },
      packed_pcs: { ascend: 'packed_pcs', descend: '-packed_pcs' },
      packed_kgs: { ascend: 'packed_kgs', descend: '-packed_kgs' },
      warehouse_pcs: { ascend: 'warehouse_pcs', descend: '-warehouse_pcs' },
      warehouse_kgs: { ascend: 'warehouse_kgs', descend: '-warehouse_kgs' },
      dispatched_pcs: { ascend: 'dispatched_pcs', descend: '-dispatched_pcs' },
      dispatched_kgs: { ascend: 'dispatched_kgs', descend: '-dispatched_kgs' },
      pending_pcs: { ascend: 'pending_pcs', descend: '-pending_pcs' },
      pending_kgs: { ascend: 'pending_kgs', descend: '-pending_kgs' },
      remark: { ascend: 'remark', descend: '-remark' },
    };
    return sortMap[sortField]?.[sortOrder] || 'id';
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedKeys => {
      if (activeFilter === 'customer' || activeFilter === 'die') {
        const priorityRowKeys = data
          .filter(record => record.is_priority === true)
          .map(record => record.id);
        const nonPriorityKeys = selectedKeys.filter(
          key => !priorityRowKeys.includes(key),
        );
        setSelectedRowKeys(nonPriorityKeys);
      } else {
        setSelectedRowKeys(selectedKeys);
      }
    },
    getCheckboxProps: record => ({
      disabled:
        (activeFilter === 'customer' || activeFilter === 'die') &&
        record.is_priority === true,
    }),
    renderCell: (checked, record, index, originNode) => {
      if (
        (activeFilter === 'customer' || activeFilter === 'die') &&
        record.is_priority === true
      ) {
        return <Checkbox checked={true} disabled={true} />;
      }
      return originNode;
    },
  };

  function addRowSpanToProfileData(data) {
    if (!Array.isArray(data) || data.length === 0) return [];
    const newData = data.map((row, idx) => ({ ...row }));

    let i = 0;
    while (i < newData.length) {
      const customer = newData[i].customer_name;
      let j = i;
      while (j < newData.length && newData[j].customer_name === customer) j++;
      let customerStart = i;
      while (customerStart < j) {
        const workorder = newData[customerStart].workorder_no;
        let k = customerStart;
        while (k < j && newData[k].workorder_no === workorder) k++;
        let workorderStart = customerStart;
        while (workorderStart < k) {
          const po = newData[workorderStart].po_no;
          let l = workorderStart;
          while (l < k && newData[l].po_no === po) l++;
          newData[workorderStart].po_rowSpan = l - workorderStart;
          for (let m = workorderStart + 1; m < l; m++)
            newData[m].po_rowSpan = 0;
          workorderStart = l;
        }
        newData[customerStart].workorder_rowSpan = k - customerStart;
        for (let m = customerStart + 1; m < k; m++)
          newData[m].workorder_rowSpan = 0;
        customerStart = k;
      }
      newData[i].customer_rowSpan = j - i;
      for (let m = i + 1; m < j; m++) newData[m].customer_rowSpan = 0;
      i = j;
    }
    return newData;
  }

  const dataSource =
    activeFilter === 'die'
      ? addRowSpanToProfileData(
        orderData.map((item, index) => ({
          ...item,
          key: item.workorder_detail_id || ``,
          SrNo: (page - 1) * pagesize + index + 1,
          customer_name: item?.customer_name || 'N/A',
          workorder_no: item.workorder_no || 'N/A',
          workorder_date: item.workorder_date || '',
          po_no: item.po_no || '',
          section: item.section || '',
          profile_image: item.profile_image || '',
          customer_reference_number: item.customer_reference_number || '',
          length: item.length || '',
          alloy_temper: item.alloy_temper || '',
          order_pcs: item.order_pcs || '',
          order_kgs: item.order_kgs || '',
          packed_pcs: item.packed_pcs || '',
          packed_kgs: item.packed_kgs || '',
          warehouse_pcs: item.warehouse_pcs || '',
          warehouse_kgs: item.warehouse_kgs || '',
          dispatched_pcs: item.dispatched_pcs || '',
          dispatched_kgs: item.dispatched_kgs || '',
          pending_pcs: item.pending_pcs || '',
          pending_kgs: item.pending_kgs || '',
          remark: item.remark || '',
          is_priority: item.is_priority || false,
        })),
      )
      : activeFilter === 'customer'
        ? orderData.map((item, index) => ({
          ...item,
          key: item.workorder_detail_id || ``,
          SrNo: (page - 1) * pagesize + index + 1,
          customer_name: item?.customer?.customer_name || 'N/A',
          workorder_no: item.workorder_no || 'N/A',
          workorder_date: item.workorder_date || '',
          po_no: item.po_no || '',
          section: item.section || '',
          profile_image: item.profile_image || '',
          customer_reference_number: item.customer_reference_number || '',
          length: item.length || '',
          alloy_temper: item.alloy_temper || '',
          order_pcs: item.order_pcs || '',
          order_kgs: item.order_kgs || '',
          packed_pcs: item.packed_pcs || '',
          packed_kgs: item.packed_kgs || '',
          warehouse_pcs: item.warehouse_pcs || '',
          warehouse_kgs: item.warehouse_kgs || '',
          dispatched_pcs: item.dispatched_pcs || '',
          dispatched_kgs: item.dispatched_kgs || '',
          pending_pcs: item.pending_pcs || '',
          pending_kgs: item.pending_kgs || '',
          total_kgs: item.total_kgs || '',
          remark: item.remark || '',
          is_priority: item.is_priority || false,
        }))
        : data
          .map((item, index) => ({
            ...item,
            key: item.id || index,
            SrNo: (page - 1) * pagesize + index + 1,
            customer_name: item?.customer?.customer_name || 'N/A',
            order_no: item.order_no || 'N/A',
            purchase_order_no: item.purchase_order_no || 'N/A',
            order_date: item.order_date || '',
            total_weight: item.total_weight || '',
            total_packed_weight: item.total_packed_weight || '',
            total_dispatched_weight: item.total_dispatched_weight || '',
            total_pending_weight: item.total_pending_weight || '',
            delivery_date: item.delivery_date || '',
            status: item.status || '',
            created_at: item.created_at || '',
            created_by: item.created_by || { first_name: '', last_name: '' },
            updated_at: item.updated_at || '',
            updated_by: item.updated_by || { first_name: '', last_name: '' },
          }));

  const handlePriority = () => {
    const formdata = {
      workorder_detail_ids: selectedRowKeys,
    };
    dispatch(createPriority({ values: formdata }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.status === 200) {
          message.success('Work Order marked as priority!');
          fetchWorkOrders({ page, pagesize, search, orderBy });
        }
      })
      .catch(error => {
        setBtnLoading(false);
        const messages = [];
        if (typeof error === 'object' && error !== null) {
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
        }
        if (messages.length > 0) {
          message.error(messages.join('; '));
        } else if (typeof error === 'string') {
          message.error(error);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const dynamicColumns = useMemo(() => {
    return activeFilter === 'customer'
      ? filterColumnsWithChildren(customerViewColumns, checkedListCustomer)
      : activeFilter === 'die'
        ? filterColumnsWithChildren(profileViewColumns, checkedListDie)
        : columns.filter(column =>
          checkedListDefault.includes(column.dataIndex),
        );
  }, [activeFilter, checkedListCustomer, checkedListDie, checkedListDefault, customerViewColumns, profileViewColumns, columns, filterColumnsWithChildren]);

  useEffect(() => {
    if (customerId) {
      setActiveFilter('customer');
    } else if (profileId) {
      setActiveFilter('die');
    } else {
      setActiveFilter(null);
    }
  }, [customerId, profileId]);

  useEffect(() => {
    if (
      (activeFilter === 'customer' && selectedCustomerId) ||
      (activeFilter === 'die' && selectedDieId)
    ) {
      fetchWorkOrderData();
    }
    if (!selectedCustomerId && !selectedDieId) {
      setOrderData([]);
    }
  }, [activeFilter, selectedCustomerId, selectedDieId, fetchWorkOrderData]);

  const uniqueCustomerList = Array.from(
    new Map(customerList.map(item => [item.id, item])).values(),
  );
  const filteredCustomerList = searchCustomer
    ? uniqueCustomerList.filter(
      el =>
        el.customer_name &&
        el.customer_name.toLowerCase().includes(searchCustomer.toLowerCase()),
    )
    : uniqueCustomerList;
  const uniqueDieProfileList = Array.from(
    new Map(dieProfileDropdown.map(item => [item.id, item])).values(),
  );

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy('');
    setCustomerId(null);
    setProfileId(null);
    setSearchCustomer('');
    setSearchDieProfile('');
    localStorage.removeItem('WorkOrderList_filter');
    dispatch(resetDieProfileOpenWorkOrderData());
    dispatch(resetCurrentCustomerPage());
    dispatch(fetchActiveCustomer({ page: 1, pagesize: 100 }));
    dispatch(fetchDieProfileByOpenWorkOrder({ page: 1, pagesize: 100 }));
    fetchWorkOrders({ page: 1, pagesize });
  };

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);
    debouncedFetchDieProfile(value);
  };

  const onScrollCustomer = event => {
    const target = event.target;

    if (
      !customerLoading &&
      customerHasMoreFromStore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      dispatch(
        fetchActiveCustomer({
          page: (customerCurrentPageFromStore || 1) + 1,
          pagesize: 50,
          search: searchCustomer,
        }),
      );
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      dispatch(
        fetchDieProfileByOpenWorkOrder({
          page: dieProfileCurrentPage + 1,
          pagesize: 50,
          search: searchDieProfile,
        }),
      );
    }
  };

  const renderSummaryRow = () => {
    const summaryMap = {
      order_pcs: 'order_pcs',
      order_kgs: 'order_kgs',
      packed_pcs: 'packed_pcs',
      packed_kgs: 'packed_kgs',
      warehouse_pcs: 'warehouse_pcs',
      warehouse_kgs: 'warehouse_kgs',
      dispatched_pcs: 'dispatched_pcs',
      dispatched_kgs: 'dispatched_kgs',
      pending_pcs: 'pending_pcs',
      pending_kgs: 'pending_kgs',
    };

    const cols =
      activeFilter === 'customer'
        ? filterColumnsWithChildren(customerViewColumns, checkedListCustomer)
        : activeFilter === 'die'
          ? filterColumnsWithChildren(profileViewColumns, checkedListDie)
          : columns.filter(column =>
            checkedListDefault.includes(column.dataIndex),
          );

    function flattenColumns(cols) {
      return cols.reduce((acc, col) => {
        if (col.children) {
          acc.push(...flattenColumns(col.children));
        } else {
          acc.push(col);
        }
        return acc;
      }, []);
    }

    const flatCols = flattenColumns(cols);
    let summaryData = total_summary;
    if (!summaryData) {
      summaryData = {};
      Object.keys(summaryMap).forEach(key => {
        summaryData[key] = 0;
      });
      (dataSource || []).forEach(row => {
        Object.keys(summaryMap).forEach(key => {
          const val = Number(row[key]);
          if (!isNaN(val)) summaryData[key] += val;
        });
      });
    }
    return (
      <Table.Summary.Row>
        {flatCols.map((col, idx) => {
          if (idx === 1) {
            if (activeFilter) {
              return (
                <Table.Summary.Cell
                  key={col.key || col.dataIndex}
                  index={idx}
                  colSpan={2}
                  style={{ textAlign: 'center' }}
                >
                  <strong>Total</strong>
                </Table.Summary.Cell>
              );
            } else {
              return (
                <Table.Summary.Cell
                  key={col.key || col.dataIndex}
                  index={idx}
                />
              );
            }
          }
          if (activeFilter && idx === 1) {
            return null;
          }
          const summaryKey = summaryMap[col.dataIndex];
          let value = summaryKey ? summaryData[summaryKey] : '';
          if (
            typeof value === 'number' &&
            col.dataIndex &&
            col.dataIndex.endsWith('kgs')
          ) {
            value = value.toFixed(2);
          }
          return (
            <Table.Summary.Cell key={col.key || col.dataIndex} index={idx}  style={{ textAlign: 'center' }}>
              <strong>
                {value !== undefined && value !== null && value !== ''
                  ? value
                  : ''}
              </strong>
            </Table.Summary.Cell>
          );
        })}
      </Table.Summary.Row>
    );
  };

  const fetchExpandedRowData = async workOrderId => {
    try {
      const response = await dispatch(fetchWorkOrderById(workOrderId)).unwrap();
      if (response?.success) {
        const expandedData = response?.data?.work_order_details || [];
        setExpandedRowData(expandedData);
      }
    } catch (error) {
      message.error('Failed to fetch work order details');
    }
  };

  const expandedRowRender = record => {
    const handlePriorityCheckbox = (id, checked) => {
      setExpandedPriorityRowKeys(prev =>
        checked ? [...prev, id] : prev.filter(key => key !== id),
      );
    };

    const handlePriorityForExpanded = () => {
      const safeExpandedRowData = Array.isArray(expandedRowData)
        ? expandedRowData
        : [];
      const nonPriorityKeys = expandedPriorityRowKeys?.filter(id => {
        const row = safeExpandedRowData.find(item => item.id === id);
        return !(row && row.is_priority);
      });
      if (nonPriorityKeys.length === 0) {
        message.warning(
          'Please select at least one non-priority row to mark as priority.',
        );
        return;
      }
      dispatch(
        createPriority({ values: { workorder_detail_ids: nonPriorityKeys } }),
      )
        .unwrap()
        .then(result => {
          message.success('Work Order marked as priority!');
          setExpandedPriorityRowKeys([]);
          fetchWorkOrders({ page, pagesize, search, orderBy });
        })
        .catch(error => {
          message.error('Failed to mark as priority');
        });
    };

    const safeExpandedRowData = Array.isArray(expandedRowData)
      ? expandedRowData
      : [];
    return (
      <div style={{ margin: '16px 0', maxHeight: 300, overflow: 'auto' }}>
        <table
          style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600 }}
        >
          <thead>
            <tr>
              <th></th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Sr.No
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Profile Number
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Profile Image
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Profile Description (mm)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Length(mm)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Pieces
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Net Weight(kg)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Packed Weight(kg)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Dispatched Weight(kg)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Pending Weight(kg)
              </th>
              <th
                style={{
                  border: '1px solid #e0e0e0',
                  padding: '8px',
                  background: '#f8f8f8',
                }}
              >
                Alloy/Temper
              </th>
            </tr>
          </thead>

          <tbody>
            {safeExpandedRowData.length > 0 ? (
              safeExpandedRowData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Checkbox
                      checked={
                        item.is_priority ||
                        expandedPriorityRowKeys.includes(item.id)
                      }
                      disabled={item.is_priority}
                      onChange={e =>
                        handlePriorityCheckbox(item.id, e.target.checked)
                      }
                    />
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'center',
                    }}
                  >
                    {index + 1}
                  </td>
                  <td style={{ border: '1px solid #e0e0e0', padding: '8px' }}>
                    {item?.die_profile?.die_number || 'N/A'}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'center',
                    }}
                  >
                    {item?.die_profile?.die_diagram ? (
                      <img
                        src={item?.die_profile?.die_diagram}
                        alt="Profile"
                        style={{
                          width: '50px',
                          height: '50px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td style={{ border: '1px solid #e0e0e0', padding: '8px' }}>
                    {(() => {
                      const dimensions = [
                        item?.die_profile?.dimension1,
                        item?.die_profile?.dimension2,
                        item?.die_profile?.dimension3,
                        item?.die_profile?.dimension4,
                      ]
                        .filter(dim => dim && dim !== '0.00')
                        .map(dim => Number(dim).toFixed(2))
                        .join(' X ');
                      return dimensions || 'N/A';
                    })()}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'center',
                    }}
                  >
                    {item.length || 0}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'center',
                    }}
                  >
                    {item.pieces || 0}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'right',
                    }}
                  >
                    {item.net_weight ? parseFloat(item.net_weight) : 0}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'right',
                    }}
                  >
                    {item.packed_weight ? parseFloat(item.packed_weight) : 0}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'right',
                    }}
                  >
                    {item.dispatched_weight
                      ? parseFloat(item.dispatched_weight)
                      : 0}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e0e0e0',
                      padding: '8px',
                      textAlign: 'right',
                    }}
                  >
                    {item.pending_weight ? parseFloat(item.pending_weight) : 0}
                  </td>
                  <td style={{ border: '1px solid #e0e0e0', padding: '8px' }}>
                    {(() => {
                      const alloyName = item?.alloy?.alloy_code || 'N/A';
                      const alloyCode = item?.alloy?.standard_name || 'N/A';
                      const temperName = item?.temper?.temper_code_new || 'N/A';
                      const temperCode = item?.temper?.temper_code_old || 'N/A';
                      return (
                        <span>
                          {alloyName} ({alloyCode}) / {temperName} ({temperCode})
                        </span>
                      );
                    })()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={12} style={{ textAlign: 'center' }}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Button
          type="primary"
          style={{ marginTop: 8 }}
          onClick={handlePriorityForExpanded}
          disabled={
            safeExpandedRowData.filter(item => !item.is_priority).length ===
            0 ||
            expandedPriorityRowKeys.filter(id => {
              const row = safeExpandedRowData.find(item => item.id === id);
              return row && !row.is_priority;
            }).length === 0
          }
        >
          Priority
        </Button>
      </div>
    );
  };

  return (
    <div>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2>Work Orders Filters</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: <Link to="/work-order-list">Work Orders</Link> },
                  { title: 'Work Orders Filters' },
                ]}
              />
            </div>
          </Col>

          
          {!activeFilter && (
             <Col flex="0 0 auto">
            <div style={{ display: 'flex', gap: 16 }}>
              <div
                style={{
                  background: '#ffff99',
                  borderRadius: 8,
                  padding: '8px 20px',
                  minWidth: 90,
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16 }}>{openWorkOrderStatisticsData?.yellow}</div>
                <div style={{ fontSize: 12 }}>8-12 Days</div>
              </div>
              <div
                style={{
                  background: '#ffd699',
                  borderRadius: 8,
                  padding: '8px 20px',
                  minWidth: 90,
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16 }}>{openWorkOrderStatisticsData?.orange}</div>
                <div style={{ fontSize: 12 }}>13-15 Days</div>
              </div>
              <div
                style={{
                  background: '#ffb3b3',
                  borderRadius: 8,
                  padding: '8px 20px',
                  minWidth: 90,
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16 }}>{openWorkOrderStatisticsData?.red}</div>
                <div style={{ fontSize: 12 }}>{'> 15 Days'}</div>
              </div>
              
            </div>
          </Col>
          )}

          <Col>
            <Space align="small">
              <AutoOpenSelect
                placeholder="Select Customer"
                style={{ width: '250px' }}
                value={customerId}
                onChange={value => {
                  setCustomerId(value);
                  setSelectedCustomerId(value);
                  setPage(1);
                }}
                showSearch
                onSearch={value => {
                  setSearchCustomer(value);
                  dispatch(resetCurrentCustomerPage());
                  dispatch({ type: 'customer/clearList' });
                  dispatch(
                    fetchActiveCustomer({ page: 1, pagesize: 50, search: value }),
                  );
                }}
                onClear={() => {
                  setCustomerId(null);
                  setSelectedCustomerId(null);
                  setSearchCustomer('');
                  dispatch(resetCurrentCustomerPage());
                  dispatch({ type: 'customer/clearList' });
                  dispatch(fetchActiveCustomer({ page: 1, pagesize: 50 }));
                }}
                onPopupScroll={onScrollCustomer}
                filterOption={false}
                loading={customerLoading}
                allowClear
                notFoundContent={customerLoading ? 'Loading...' : 'No data'}
              >
                {filteredCustomerList.map(el => (
                  <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                    {el.customer_name}
                  </Option>
                ))}
              </AutoOpenSelect>
              <AutoOpenSelect
                placeholder="Select Profile No"
                value={profileId}
                onChange={value => {
                  setProfileId(value);
                  setSelectedDieId(value);
                  setPage(1);
                }}
                showSearch
                onSearch={handleSearchDieProfile}
                onClear={() => {
                  setProfileId(null);
                  setSelectedDieId(null);
                  setSearchDieProfile('');
                  dispatch(resetDieProfileOpenWorkOrderData());
                  dispatch(fetchDieProfileByOpenWorkOrder({ page: 1, pagesize: 50 }));
                }}
                onPopupScroll={onScrollDieProfile}
                filterOption={false}
                loading={dieProfileLoading}
                allowClear
              >
                {uniqueDieProfileList.map(el => (
                  <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                    {el.die_number}
                  </Option>
                ))}
              </AutoOpenSelect>
              {!activeFilter && (
                <>
                  <Input
                    placeholder="Search"
                    className="searchbox"
                    prefix={<SearchOutlined />}
                    value={inputValue}
                    onChange={handleSearch}
                    style={{ flex: 1, minWidth: 150 }}
                  />
                </>
              )}
              <Tooltip title="Filter">
                <Button
                  type="primary"
                  disabled={!search && !orderBy && !customerId && !profileId}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>
              {currentUser.permissions.permissions.workorder.includes(
                'print_workorder_copy',
              ) && (
                  <>
                    <Tooltip title="Print">
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handleButtonClick}
                      >
                        <PrintIcon />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Export to Excel">
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handleExcelExport}
                      >
                        <FileExcelOutlined />
                      </Button>
                    </Tooltip>
                  </>
                )}
              {!activeFilter && (
                <Tooltip placement="topLeft" title="Column Filter Options">
                  <Dropdown
                    overlay={columnMenu}
                    trigger={['click']}
                    placement="bottomRight"
                    open={dropdownVisible}
                    onVisibleChange={setDropdownVisible}
                  >
                    <Button type="primary" icon={<ColumnList />} />
                  </Dropdown>
                </Tooltip>
              )}
              {activeFilter && (
                <Tooltip
                  placement="top"
                  title={'Move the selected Item in Priority'}
                >
                  <Button
                    type="primary"
                    style={{ float: 'right' }}
                    onClick={handlePriority}
                    disabled={selectedRowKeys.length === 0}
                  >
                    Priority
                  </Button>
                </Tooltip>
              )}
            </Space>
          </Col>
        </Row>
      </div>

      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          <Table
            rowKey="key"
            columns={dynamicColumns}
            rowSelection={
              activeFilter
                ? {
                  ...rowSelection,
                  columnWidth: 30,
                }
                : undefined
            }
            expandable={
              !activeFilter
                ? {
                  expandedRowRender,
                  rowExpandable: record => true,
                  expandedRowKeys,
                  onExpand: (expanded, record) => {
                    if (expanded) {
                      setExpandedRowKeys(prev => [...prev, record.key]);
                      fetchExpandedRowData(record.id);
                    } else {
                      setExpandedRowKeys(prev =>
                        prev.filter(key => key !== record.key),
                      );
                    }
                  },
                  expandIcon: ({ expanded, onExpand, record }) => (
                    <span
                      onClick={e => onExpand(record, e)}
                      style={{ cursor: 'pointer', marginRight: 8 }}
                    >
                      {expanded ? '−' : '+'}
                    </span>
                  ),
                }
                : undefined
            }
            dataSource={dataSource}
            pagination={false}
            loading={loading || isLoading}
            scroll={{ x: '1000px' }}
            onChange={handleTableChange}
            summary={renderSummaryRow}
            rowClassName={(record, index) => {
              const nextRecord = dataSource[index + 1];
              if (
                !nextRecord ||
                record.workorder_no !== nextRecord.workorder_no
              ) {
                return 'group-separator-row';
              }
              return '';
            }}
          />
        </div>
      </div>
      <style>
        {`
        .ant-table-wrapper {
            background-color: #fff;
        }

        ant-table {
          border: 1px solid #e0e0e0;
          font-family: 'Arial', sans-serif;
          font-size: 13px;
        }

        .ant-table-thead > tr > th {
          background-color: #f8f8f8;
          border: 1px solid #e0e0e0;
          font-weight: 600;
          color: #000;
          font-size: 13px;
          padding: 8px 10px;
          text-align: center;
          white-space: nowrap;
        }

        .ant-table-tbody > tr > td {
          border: 1px solid #e0e0e0;
          background-color: #fff;
          padding: 8px 10px;
          text-align: center;
          vertical-align: middle;
          font-size: 13px;
        }
        .group-separator-row td {
          border-bottom: 3px solid #444;
          background-color: #fff;
        }

        .ant-table-tbody > tr:hover > td {
          background-color: #f5f5f5;
        }

        .ant-table-thead > tr > th:first-child,
        .ant-table-tbody > tr > td:first-child {
          text-align: left; /* For Sr No. */
        }

    `}
      </style>
    </div>
  );
}

export default WorkOrderFilterList;
